import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';
import Getintouch from '../Home/Getintouch';
interface gallerydata{
    id:number,
    image:string,
  }
const Gallery = () => {
  const api = process.env.REACT_APP_API_URL as string;
    const[galleryimagedata, setGalleryImagedata] = useState<gallerydata[]>([]);
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get<gallerydata[]>(
            `${api}/auth/gallery`
          );
  
          //console.log('gallery data',response.data)
          setGalleryImagedata(response.data);
        } catch (error) {
          console.error("gallery Not Found:", error);
        }
      };
  
      fetchData();
    }, []);
  return (
    <div>
         <Header />
         <div className="bg-[#1E2A3A]   py-[50px] px-[8%]">
    <p className="text-[#F1F4F9] text-[16px] text-center">Stories FROM</p>
    <div className=" relative z-10 text-[#FDBC12] text-[39px] font-bold text-center">
      <h2 className="leading-12	">Event and Meetings</h2>
    </div>
    
    <div className="flex flex-wrap sm:justify-between justify-center gap-y-4  mt-6">
      {galleryimagedata.map((image)=>(
      <img className="md:w-[24%]  sm:w-[48%]" src={`${api}/${image.image}`} alt="" />
      ))}
    </div>
  </div>
  <Getintouch />
  <Footer />
  </div>
  )
}

export default Gallery